import React, { ReactElement, useEffect } from 'react'
import axios from 'axios'
import { ArtData } from '@/database/art'
import serverConfig from '@/server-config'
import ModelMintCardDetails from '@/components/mint/ModalMintCardDetails'
import Vote from '@/components/boxes/Vote'
import ModelButtons from '@/components/ModalButtons'

axios.defaults.baseURL = serverConfig.baseURL

const DetailsOverview = ({ artData, onClose }: { artData: ArtData; onClose: () => void }): ReactElement => {
    useEffect(() => {
        window.location.hash = `art-${artData.art?.id}#mint`
    }, [artData])

    return (
        <div>
            <h1 className="title">CRAZY ART #{artData.art.id}</h1>
            <ModelButtons artData={artData} onClose={onClose} />
            <div className="menu-wrapper-column-position">
                <Vote artData={artData} />
            </div>
            <div className="container">
                <div>
                    <ModelMintCardDetails artData={artData} onClose={onClose} />
                </div>
            </div>
        </div>
    )
}

export default DetailsOverview
